import * as Yup from 'yup';
// import { startOfToday } from 'date-fns';

/**
 * Validation schema for fetching travel requirements
 */

const TravelRequirementsReqSchema = Yup.object().shape({
  destinationCountryCode: Yup.string()
    .required('Destination country is required')
    .length(2)
    .nullable(),
  nationality: Yup.string()
    .required('Your nationality is required')
    .length(2)
    .nullable(),
  departureAirportCode: Yup.string()
    .required('Origin country is required')
    .length(2)
    .nullable(),
  residentCountryCode: Yup.string()
    .required('Your resident country is required')
    .length(2)
    .nullable(),
  /* arrivalDate: Yup.date()
    .min(startOfToday())
    .required('Arrival date is required')
    .nullable(), */
  transitAirports: Yup.array().max(5, 'Select a maximum of 5 transit airports'),
  //   documentType: Yup.string().required('Passport type is required').nullable(),
});

export { TravelRequirementsReqSchema };
